import { render, staticRenderFns } from "./safeScreenSet.vue?vue&type=template&id=8ba2a816&scoped=true&"
import script from "./safeScreenSet.vue?vue&type=script&lang=js&"
export * from "./safeScreenSet.vue?vue&type=script&lang=js&"
import style0 from "./safeScreenSet.vue?vue&type=style&index=0&id=8ba2a816&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba2a816",
  null
  
)

export default component.exports